
export default {
  props: {
    favorite: {type: Boolean, required: true},
    size: {type: String, default: '1.6rem'}
  }
}
